import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { registerSW } from "virtual:pwa-register";
import { App } from "./App";
import "./styles.css";

const updateServiceWorker = registerSW({
  immediate: true,
  onNeedRefresh() {
    window.dispatchEvent(new CustomEvent("stimulantnoise:update-ready"));
  },
  onOfflineReady() {
    window.dispatchEvent(new CustomEvent("stimulantnoise:offline-ready"));
  }
});

window.addEventListener("stimulantnoise:apply-update", () => void updateServiceWorker(true));

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);

